import BaseBlock from "./BaseBlock";
import Main from "@/ts/base/Main";
import {Modal} from "bootstrap";
import ModalOptions from "@/ts/base/Interfaces/ModalOptions";
import ModalTemplate from "@/ts/base/Utils/ModalTemplate";

class Vote extends BaseBlock {

    init(): void {
        const titleEl = this.block.querySelector(".vote-title");
        if (titleEl instanceof HTMLElement) {
            titleEl.prepend((this.index + 1) + ". ");
        }
        this.block.querySelector(".vote-button:enabled")?.addEventListener("click", this.onVoteButtonClick.bind(this));
    }

    protected onVoteButtonClick(e: Event) {
        const btn = <HTMLButtonElement>e.currentTarget;
        const icon = btn.querySelector("i");
        const voteResult = btn.previousElementSibling;
        const data = new FormData();
        const blockId = btn.getAttribute('data-block-id');
        const nonceEl = document.querySelector(`input#vote_wp_nonce_${blockId}`)

		if (!(nonceEl instanceof HTMLInputElement)) {
			return;
		}

        data.append("action", "Vote/AddBlock");
        data.append("nonce", nonceEl.value);
        data.append("blockID", String(btn.getAttribute('data-block-id')));
        data.append("postID", String(btn.getAttribute('data-post-id')));
        data.append("votesInitial", String(btn.getAttribute('data-votes-initial')));

        btn.disabled = true;

		if (icon instanceof HTMLElement) {
			icon.classList.remove("fa-thumbs-o-up");
			icon.classList.add("fa-circle-o-notch", "fa-spin");
		}


        window.fetch(Main.Instance.options.url.ajax, {
            body: data,
            method: "post"
        }).then(async (response) => {

			if (icon) {
				icon.classList.remove("fa-circle-o-notch", "fa-spin");
				icon.classList.add('fa-thumbs-o-up');
			}


            const result = await response.json();
            btn.removeEventListener("click", this.onVoteButtonClick.bind(this));

            if (result.errorMessage) {
                this.displayError(result.errorMessage);
            }
            else if (voteResult) {
                voteResult.innerHTML = result.data.html;
            }
        });
    }

    protected displayError(message: string) {
		const options: ModalOptions = {
			id: this.getBlockDataId().concat("__VoteError"),
			variant: "error",
			buttons: [
				`<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Okay</button>`
			]
		};

        switch (message) {
            case 'error: voted block':
				options.title = "It looks like you voted for this contestant in the last 24 hours.";
				options.message = "Please come back tomorrow to vote again.";
                break;

            case 'error: daily max':
				options.title = "It looks like you voted the maximum allowed times in the last 24 hours.";
				options.message = "Please come back tomorrow to continue voting for your favorite contestants.";
                break;
        }

		const tpl: ModalTemplate = new ModalTemplate(options);

		(new Modal(tpl.insert())).show();
    }
}

export default Vote;
